import { normalizeLink } from "@utils/sharedFunctions"
export default function SocialComponent(props:{socialName:string, value: string| undefined}) {
    
    return (   
        <a href={`${normalizeLink(props.value) ?? `https://${props.socialName}.com`}`} target="_blank" key={props.socialName}>
            <img src={`/images/${props?.socialName}.png`} alt="" className="social-icon" />
        </a>   
    )
}